import React from "react";
import PropTypes from "prop-types";
import decodeHTMLEntities from "core-web/utils/decodeHTMLEntities";
import AspectWrapper from "core-web/components/AspectWrapper";
import Link from "core-web/components/Link";
import styled from "theme/libs/styled";
import TextStyles from "theme/components/text/TextStyles";
import { PLACEHOLDER } from "theme/config/constants";
import Image from "core-web/components/Image";

const CategoryLink = styled(Link)`
    display: flex;
    height: 72px;
    align-items: center;
    gap: 16px;
    border-radius: 6px;
    transition: background ${({ theme }) => theme.transitions.primary};

    :hover,
    :focus,
    &[data-is-current="true"] {
        background: ${({ theme }) => theme.colors.neutral_50};
    }
`;

const ImageWrapper = styled(AspectWrapper)`
    background-color: ${({ theme }) => theme.colors.neutral_50};
    border-radius: 6px;
    width: 72px;
    height: 72px;
    padding: 10px;
    overflow: hidden;
    mix-blend-mode: multiply;
`;

const CategoryCard = ({ callback, imageLoading, url, title, image = null, textStyles, isCurrent = false, ...rest }) => {
    return (
        <CategoryLink
            isvolatile
            as={url ? Link : "div"}
            to={url}
            onClick={callback}
            data-is-current={isCurrent}
            {...rest}
        >
            {image && (
                <ImageWrapper ratios="1">
                    <Image
                        mixBlendMode="multiply"
                        loading={imageLoading}
                        alt={title}
                        title={title}
                        src={{
                            url: image || PLACEHOLDER,
                            width: 100,
                            f: "webp",
                        }}
                        width="72px"
                        objectFit="cover"
                        wrapperStyle={{
                            borderRadius: "4px",
                        }}
                    />
                </ImageWrapper>
            )}
            <TextStyles whiteSpace="nowrap" textStyles={textStyles}>
                {decodeHTMLEntities(title)}
            </TextStyles>
        </CategoryLink>
    );
};

CategoryCard.propTypes = {
    callback: PropTypes.func,
    image: PropTypes.string,
    imageLoading: PropTypes.string,
    textPos: PropTypes.string.isRequired,
    textStyles: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
    title: PropTypes.string,
    url: PropTypes.string,
};

CategoryCard.defaultProps = {
    callback: undefined,
    imageLoading: "lazy",
    title: "",
    url: "",
};

export default CategoryCard;
